<template>
    <div>
        <div class="form__page -pt-nav">

            <img src="@/assets/bg__allforms.png" alt="" class="form__allforms" />

            <div class="container d-flex justify-content-center">
                <div class="form__page-content col-sm-20 form__allforms-content">

                    <div class="form__row text-center -pb-3">
                        <p class="heading-32 form__title form__pb-8">Formularz zgłoszeniowy — etap II</p>
                        <p class="text-20">Program grantowy dla organizacji</p>
                    </div>

                    <div class="form__row -pt-4">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                Dane Organizcji
                            </p>
                        </div>
                        <organization-data />
                    </div>

                    <div class="form__row -pt-4">
                        <div class="text-center">
                            <p class="form__title heading-32 -pb-4">
                                Dane osoby reprezentującej
                            </p>
                            <div class="d-flex justify-content-center text-danger">
                                <p class="col-24 col-sm-14 text-16">W przypadku zmiany danych osoby reprezentującej
                                    należy wypełnić Załącznik nr 2 do regulaminu i dodać jako załącznik do niniejszego
                                    formularza.</p>
                            </div>
                        </div>
                        <reporting-person />
                    </div>

                    <div class="form__row -pt-4">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                Informacje o projekcie
                            </p>
                        </div>
                        <project-data />
                    </div>

                    <div class="form__row -pt-4">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                Załączniki
                            </p>
                        </div>
                        <attachments-data />
                    </div>

                    <div class="form__row form__rights">
                        <p class="text-center heading-32 form__title">Oświadczenia</p>

                        <div class="heading-16 form__pt-24" v-for="contactTerm of contactTerms" :key="contactTerm.id">
                            <p v-if="!readMoreActivated[contactTerm.id]"
                                class="text-start heading-16 form__description">
                                <span v-html="contactTerm.description.slice(0, 111)"></span>
                                <span
                                    v-if="!readMoreActivated[contactTerm.id] && contactTerm.description.length - 1 > 251"
                                    class="text-start text-16" @click.prevent="checkmarkExpand([contactTerm.id])">...
                                    <span class="heading-16 cur-pointer">rozwiń</span></span>

                                <!-- {{contactTerm.description}} <span v-html="contactTerm.description"></span> -->

                            </p>
                            <p v-if="readMoreActivated[contactTerm.id]" class="form__description">
                                <span v-html="contactTerm.description"></span>
                                <span class="form__checkmark-collapse text-start heading-16 cur-pointer"
                                    v-if="readMoreActivated[contactTerm.id]"
                                    @click.prevent="checkmarkCollapse([contactTerm.id])">zwiń</span>
                            </p>
                        </div>

                        <div class="form-check form__pt-24 d-flex align-items-center form__gap-16">
                            <input v-model="agreement_all" class="form-check-input" type="checkbox" value=""
                                id="flexCheckDefault">
                            <label class="form-check-label heading-16" for="flexCheckDefault">
                                Zaznacz wszystkie
                            </label>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-items-sm-center form__gap-16">
                                <input v-model="agreement_1" class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_1_error }" type="checkbox" value="1"
                                    id="flexCheckDefault-1">
                                <label class="form-check-label text-16" for="flexCheckDefault-1">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Oświadczam, że wszystkie dane zamieszczone w niniejszym formularzu i w
                                        dokumentach do niego załączonych są zgodne z prawdą i stanem faktycznym oraz że
                                        podaję je dobrowolnie.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_1_error">
                                {{ agreement_1_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-items-sm-center form__gap-16">
                                <input v-model="agreement_2" class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_2_error }" type="checkbox" value="1"
                                    id="flexCheckDefault-2">
                                <label class="form-check-label text-16" for="flexCheckDefault-2">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span>
                                        Potwierdzam, że zapoznałem się z regulaminem akcji „Enea Akademia Talentów” oraz
                                        załącznikami do niego, wyrażam zgodę na jego postanowienia i zobowiązuję się do
                                        przestrzegania określonych w nim zasad.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_2_error">
                                {{ agreement_2_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex form__gap-16">
                                <input v-model="agreement_3" class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_3_error }" type="checkbox" value="1"
                                    id="flexCheckDefault-3">
                                <label class="form-check-label text-16" for="flexCheckDefault-3">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> Oświadczam i zapewniam,
                                        odpowiednio że:
                                        a. Organizacji przysługują wszelkie prawa i uprawnienia, w tym licencja lub
                                        autorskie prawa majątkowe i prawa pokrewne do Zadania konkursowego co najmniej w
                                        zakresie wymaganym w Regulaminie i załącznikach do niego (tj. Organizacja
                                        skutecznie nabyła je od wszystkich twórców Zadania konkursowego oraz artystów -
                                        wykonawców, występujących w Zadaniu konkursowym z prawem do dalszego
                                        przenoszenia tych praw, co najmniej w zakresie opisanym w Regulaminie i
                                        załącznikach do niego);<br>
                                        b. Zadanie konkursowe nie jest w żaden sposób obciążone oraz nie narusza praw
                                        osób trzecich, w tym w szczególności praw autorskich, praw pokrewnych, praw
                                        własności przemysłowej ani dóbr osobistych; <br>
                                        c. Organizacja posiada prawa do wykorzystania i rozpowszechniania w ramach
                                        Zadania konkursowego wizerunków i głosów osób trzecich, przedmiotów praw osób
                                        trzecich, w tym utworów (w rozumieniu ustawy z dnia 4 lutego 1994 roku o prawie
                                        autorskim i prawach pokrewnych) stworzonych przez osoby trzecie, praw do
                                        artystycznych wykonań osób trzecich, jeśli wizerunki lub głosy tych osób, ich
                                        utwory lub artystyczne wykonania i inne przedmioty praw znajdują się na/zostały
                                        utrwalone w Zadaniu konkursowym - aby możliwym było udzielenie licencji i
                                        sublicencji Organizatorowi i Współorganizatorowi oraz udzielenie zgody na
                                        wykorzystanie i rozpowszechnianie wizerunków i głosów osób utrwalonych w Zadaniu
                                        konkursowym na warunkach i w zakresie opisanym w Regulaminie i jego
                                        załącznikach; <br>
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_3_error">
                                {{ agreement_3_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex form__gap-16">
                                <input v-model="agreement_4" class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_4_error }" type="checkbox" value="1"
                                    id="flexCheckDefault-4">
                                <label class="form-check-label text-16" for="flexCheckDefault-4">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">* </span>
                                        Udzielam Organizatorowi i Współorganizatorowi nieodpłatnej, niewyłącznej
                                        licencji do Zadania konkursowego (licencja w zakresie praw autorskich
                                        majątkowych i praw pokrewnych do Zadania konkursowego), a jeśli w Zadaniu
                                        konkursowym zostały utrwalone utwory stworzone przez osoby trzecie lub
                                        artystyczne wykonania osób trzecich – udzielam do nich nieodpłatnie sublicencji,
                                        na następujących polach eksploatacji:
                                        a. utrwalanie i zwielokrotnianie Zadania konkursowego jakąkolwiek techniką, w
                                        tym na płycie CD, nośnikach elektronicznych, w formie drukowanej; <br>
                                        b. wprowadzanie Zadania konkursowego do pamięci komputera oraz przechowywanie
                                        Zadania konkursowego w pamięci komputera w celu wskazanym w lit. c poniżej; <br>
                                        c. wykorzystanie i rozpowszechnianie Zadania konkursowego oraz jego
                                        upublicznienie na stronie internetowej www.akademiatalentow.enea.pl.<br>
                                        Licencja i sublicencja jest udzielana na czas trwania Akcji, a w przypadku
                                        wygranej przez Organizację - na okres do dnia 31 grudnia 2027 roku – tj. na czas
                                        do zakończenia programu grantowego. <br>
                                        Jednocześnie upoważniam Organizatora i Współorganizatora do wykonywania w
                                        imieniu Organizacji (jeżeli zarejestrowana jest na osobę fizyczną) oraz w
                                        imieniu osób, których utwory lub artystyczne wykonania zostały wykorzystane w
                                        Zadaniu konkursowym przysługujących Organizacji i ww. osobom autorskich praw
                                        osobistych oraz do decydowania o przystąpieniu do rozpowszechniania Zadania
                                        konkursowego w sposób opisany wyżej oraz o oznaczeniu Zadania konkursowego
                                        imieniem i nazwiskiem autorów lub o braku takiego oznaczenia. <br>
                                        W zakresie i czasie opisanym wyżej wyrażam także zgodę na wykorzystanie i
                                        rozpowszechnienie wizerunku i głosu osób trzecich, o ile zostały utrwalone w
                                        Zadaniu konkursowym.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_4_error">
                                {{ agreement_4_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex form__gap-16">
                                <input v-model="agreement_5" class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_5_error }" type="checkbox" value="1"
                                    id="flexCheckDefault-5">
                                <label class="form-check-label text-16" for="flexCheckDefault-5">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">* </span>
                                        Udzielam Organizatorowi i Współorganizatorowi nieodpłatnej i niewyłącznej
                                        licencji do przesłanego Zdjęcia i wyraża zgodę na zamieszczenie Zdjęcia oraz
                                        publikację danych Organizacji tj. nazwa Organizacji, miejscowość, w której
                                        będzie realizowany Projekt, nazwa Projektu, dane zawarte w sekcji „Opis
                                        Projektu, który znajdzie się na stronie Enea Akademia Talentów” (z Formularza
                                        zgłoszeniowego II Etapu) na stronie internetowej Akcji pod adresem
                                        www.akademiatalentow.enea.pl celem stworzenia profilu Organizacji i umożliwienia
                                        Internautom głosowania na Organizację i jej Zadanie konkursowe – na czas trwania
                                        Akcji, a w przypadku wygranej dodatkowo na zamieszczenie Zdjęcia oraz danych
                                        Organizacji wskazanych wyżej na stronie internetowej Akcji w zakładce Zwycięzcy
                                        Akcji 2025/2026 – do dnia 31 grudnia 2027 roku tj. do zakończenia programu
                                        grantowego.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_5_error">
                                {{ agreement_5_error }}
                            </div>
                        </div>
                        <p class="text-danger text-center form__pt-24">Oświadczenia, które należy zaznaczyć, jeśli w
                            zadaniu konkursowym zostały utrwalone
                            jakiekolwiek wizerunki i/lub głosy.</p>
                        <div class="form-check form__pt-24">
                            <div class="d-flex form__gap-16">
                                <input v-model="agreement_6" class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_6_error }" type="checkbox" value="1"
                                    id="flexCheckDefault-6">
                                <label class="form-check-label text-16" for="flexCheckDefault-6">
                                    <p class="description-16">
                                        Oświadczam, że osoby, których wizerunki lub głosy zostały utrwalone w Zadaniu
                                        konkursowym udzieliły zgody na wykorzystanie i rozpowszechnianie ich wizerunku i
                                        głosu o treści określonej w Załączniku nr 3b do Regulaminu akcji „Enea Akademia
                                        talentów”
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_6_error">
                                {{ agreement_6_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex form__gap-16">
                                <input v-model="agreement_7" class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_7_error }" type="checkbox" value="1"
                                    id="flexCheckDefault-7">
                                <label class="form-check-label text-16" for="flexCheckDefault-7">
                                    <p class="description-16">
                                        Oświadczam, że osoby, których wizerunki lub głosy zostały utrwalone w Zadaniu
                                        konkursowym udzieliły zgody na przetwarzanie ich danych osobowych o treści
                                        określonej w Załączniku nr 3d do Regulaminu
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_7_error">
                                {{ agreement_7_error }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center -pb-6">
                        <button class="button__red form__btn" @click="sendForm" :disabled="sendFormLoader">
                            <div v-if="sendFormLoader">
                                <svg style="width: 20px; height: 20px;" version="1.1" id="L9"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0"
                                    xml:space="preserve">
                                    <path fill="#fff"
                                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                        <animateTransform attributeName="transform" attributeType="XML" type="rotate"
                                            dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                                    </path>
                                </svg>
                            </div>
                            <span>Zapisz&nbsp;i&nbsp;wyślij</span>
                            <img src="@/assets/right-btn.svg" alt="" class="button__arrow" />
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <transition name="fade">
            <modal-success v-if="showModal.show" @close-modal="() => showModal.show = false" :type="showModal.type" />
        </transition>

    </div>
</template>

<script>
import OrganizationData from "@/components/forms/OrganizationDataStep2.vue";
import ModalSuccess from "@/components/forms/ModalSuccess.vue";
import ReportingPerson from "@/components/forms/ReportingPersonOrganizationStep2.vue";
import ProjectData from "@/components/forms/ProjectDataStep2.vue";
import AttachmentsData from "@/components/forms/AttachmentsData.vue";
import axios from "axios";

export default {
    data() {
        return {
            sendFormLoader: false,
            agreement_all: false,
            agreement_1: false,
            agreement_2: false,
            agreement_3: false,
            agreement_4: false,
            agreement_5: false,
            agreement_6: false,
            agreement_7: false,
            showModal: {
                type: 'success',
                show: false,
            },
            showModalDispaly: 'none',
            errors: [],
            searchText: '',
            inputs: {
                organization_desc: {
                    type: 'textarea',
                    title: 'Opis organizacji',
                    placeholder: 'Opis organizacji',
                    subtitle: null,
                    mandatory: '*',
                    model: 'organization_desc',
                    stage: 'formOrganizationStep2.organization.organization_desc'
                },

            },
            readMoreActivated: {},
            contactTerms: [
                {
                    id: "1",
                    description:
                        "Współadministratorem danych osobowych  Osób Reprezentujących wedle definicji z Regulaminu Akcji dla Organizacji, osób, których wizerunek lub głos został utrwalony w Zadaniu konkursowym oraz osób, których utwory lub artystyczne wykonania zostały wykorzystane w Zadaniu konkursowym jest  Enea S.A. z siedzibą w Poznaniu (60-198), przy Pastelowej 8, wpisana do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań - Nowe Miasto i Wilda w Poznaniu, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000012483, NIP 777-00-20-640, REGON 630139960, kapitał zakładowy: 529 731 093 zł wpłacony w całości oraz Fundacja Enea - Energia Wspólnoty z siedzibą w Poznaniu (60-198), przy Pastelowej 8 wpisana do rejestru stowarzyszeń, innych organizacji społecznych i zawodowych, fundacji oraz samodzielnych publicznych zakładów opieki zdrowotnej Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań – Nowe Miasto i Wilda, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0001162550, NIP: 7792585651, REGON: 541217485. <br> Dane osobowe będą przetwarzane zgodnie z przepisami Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE - Dz. U. UE. L. z 2016 r. Nr 119/1 (RODO) w  celach związanych z realizacją Akcji, w tym w celu kontaktu z Wnioskodawcą, oceny jego zgłoszenia do udziału w Akcji, zakwalifikowania do II Etapu Akcji, ogłoszenia wyników, wydania Nagrody, rozpatrzenia reklamacji, w związku z możliwością ustalenia, dochodzenia lub obrony roszczeń. <br> Podstawą przetwarzania danych osobowych jest zgoda w oparciu o art. 6 ust. 1 lit. a) RODO w celach związanych z realizacją Akcji, w tym w celu kontaktu z Wnioskodawcą, oceny jego zgłoszenia do udziału w Akcji, zakwalifikowania do II Etapu Akcji, ogłoszenia wyników, wydania Nagrody, rozpatrzenia reklamacji, a w zakresie danych przetwarzanych w związku z możliwością ustalenia, dochodzenia lub obrony roszczeń, na podstawie art. 6 ust. 1 lit. f) RODO. <br> Dane osobowe będą przetwarzane do 31 marca 2027 roku, a w przypadku przyznania grantu przez okres do 31 grudnia 2027 r., a po tym okresie – dla celów związanych z możliwością ustalenia, dochodzenia lub obrony roszczeń - przez czas niezbędny do ich ustalenia, dochodzenia lub obrony, nie dłużej jednak niż do upływu okresu przedawnienia. <br> W odniesieniu do danych osobowych przetwarzanych na podstawie zgody osoba, której dane dotyczą ma prawo do cofnięcia zgody w dowolnym momencie, przy czym wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. Cofnięcie zgody jest możliwe w formie pisemnej poprzez przesłanie jej na adres: Inspektor Ochrony Danych (IOD) Enea S.A., ul. Pastelowa 8, 60-198 Poznań lub na adres mailowy esa.iod@enea.pl <br> Osoba, której dane dotyczą ma prawo żądania: <br> a.	dostępu do treści swoich danych - w granicach art. 15 RODO, <br> b.	ich sprostowania – w granicach art. 16 RODO, <br> c.	ich usunięcia - w granicach art. 17 RODO, <br> d.	ograniczenia przetwarzania - w granicach art. 18 RODO, <br> e.	przenoszenia danych - w granicach art. 20 RODO, <br> f.	wniesienia sprzeciwu wobec przetwarzania danych osobowych opartego na art. 6 ust. 1 lit. f) RODO - w granicach art. 21 RODO. <br> Współadministrator może ujawnić dane osobowe podmiotom upoważnionym na podstawie przepisów prawa. <br>  Współadministrator może również powierzyć przetwarzanie danych osobowych dostawcom usług lub produktów działającym na jego rzecz, w szczególności podmiotom świadczącym Administratorowi usługi IT, księgowe, transportowe, serwisowe, agencyjne. <br> Zgodnie z zawartymi z takimi podmiotami umowami powierzenia przetwarzania danych osobowych, Współadministrator wymaga od tych dostawców usług zgodnego z przepisami prawa, wysokiego stopnia ochrony prywatności i bezpieczeństwa danych osobowych przetwarzanych przez nich w imieniu Współadministratora. <br> Współadministratorzy postanowili o ustanowieniu wspólnego punktu kontaktowego wobec czego realizacja praw, o których mowa powyżej może odbywać się poprzez wskazanie żądań przesłane na adres: esa.iod@enea.pl  lub pisemnie na adres: Inspektor Ochrony Danych (IOD) Enea S.A., ul. Pastelowa 8, 60-198 Poznań. <br> Niezależnie od powyższego każdy ze Współadministratorów ponosi solidarną odpowiedzialność za wszelkie naruszenia w procesie przetwarzania danych.  Osoba, której dane dotyczą może zgłosić swoje roszczenia wybranemu Współadministratorowi, który będzie zobowiązany do naprawienia szkody, nawet jeśli wyrządził ją inny Współadministrator. Tym samym, osoba, której dane dotyczą, ma prawo do kierowania roszczeń przeciwko któremukolwiek ze Współadministratorów. <br> Osoba, której dane dotyczą ma prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna, iż przetwarzanie danych osobowych jej dotyczących narusza przepisy prawa dotyczące przetwarzania danych osobowych.<br> Dane osobowe nie będą przekazywane do państwa trzeciego/organizacji międzynarodowej. <br> W oparciu o dane osobowe Współadministrator nie będzie podejmował decyzji sposób zautomatyzowany, w tym również w formie profilowania. <br> Administratorem danych osobowych przetwarzanych w celu wykonania Umowy o grant oraz w celu przekazania Nagrody - wypłaty Grantu, jest Fundacja Enea - Energia Wspólnoty z siedzibą w Poznaniu (60-198), przy Pastelowej 8 wpisana do rejestru stowarzyszeń, innych organizacji społecznych i zawodowych, fundacji oraz samodzielnych publicznych zakładów opieki zdrowotnej Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań – Nowe Miasto i Wilda, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0001162550, NIP: 7792585651, REGON: 541217485. Szczegółowa treść klauzuli informacyjna dołączona do wzoru Umowy o grant stanowiącej załącznik do Regulaminu Akcji dla Organizacji. ",
                    checked: false,
                    required: true,
                },
            ],
        }
    },
    mounted() {
        this.$store.commit('removeAllErrors');
        this.$store.commit('resetFormOrganization');
    },
    watch: {
        agreement_all(newVal) {
            if (newVal) {
                this.agreement_1 = true;
                this.agreement_2 = true;
                this.agreement_3 = true;
                this.agreement_4 = true;
                this.agreement_5 = true;
                this.agreement_6 = true;
                this.agreement_7 = true;
            }
        },
        agreement_1(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formOrganizationStep2.application.agreement_1', !newVal ? null : true);
            this.$store.commit('removeError', 'formOrganizationStep2.application.agreement_1')
        },
        agreement_2(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formOrganizationStep2.application.agreement_2', !newVal ? null : true);
            this.$store.commit('removeError', 'formOrganizationStep2.application.agreement_2')
        },
        agreement_3(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formOrganizationStep2.application.agreement_3', !newVal ? null : true);
            this.$store.commit('removeError', 'formOrganizationStep2.application.agreement_3')
        },
        agreement_4(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formOrganizationStep2.application.agreement_4', !newVal ? null : true);
            this.$store.commit('removeError', 'formOrganizationStep2.application.agreement_4')
        },
        agreement_5(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formOrganizationStep2.application.agreement_5', !newVal ? null : true);
            this.$store.commit('removeError', 'formOrganizationStep2.application.agreement_5')
        },
        agreement_6(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formOrganizationStep2.application.agreement_6', !newVal ? null : true);
            this.$store.commit('removeError', 'formOrganizationStep2.application.agreement_6')
        },
        agreement_7(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formOrganizationStep2.application.agreement_7', !newVal ? null : true);
            this.$store.commit('removeError', 'formOrganizationStep2.application.agreement_7')
        },
    },
    components: {
        // forms
        OrganizationData,
        ReportingPerson,
        ProjectData,
        ModalSuccess,
        AttachmentsData
    },
    computed: {
        agreement_1_error() {
            const error = this.$store.getters.getError('application.agreement_1');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_2_error() {
            const error = this.$store.getters.getError('application.agreement_2');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_3_error() {
            const error = this.$store.getters.getError('application.agreement_3');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_4_error() {
            const error = this.$store.getters.getError('application.agreement_4');
            if (error && error.length)
                return error[0]

            return null
        },
        recaptcha_error() {
            const error = this.$store.getters.getError('grecaptcha_token');
            if (error && error.length)
                return error[0]

            return null
        }
    },
    methods: {
        checkmarkExpand(id) {
            this.readMoreActivated[id] = true;
        },
        checkmarkCollapse(id) {
            this.readMoreActivated[id] = false;
        },
        scrollToElement() {
            setTimeout(() => {

                const el = document.querySelector('.text-danger');

                if (el) {
                    // Use el.scrollIntoView() to instantly scroll to the element
                    el.scrollIntoView({ behavior: 'smooth' });

                    const pos = el.style.position;
                    const top = el.style.top;
                    el.style.position = 'relative';
                    el.style.top = '-200px';
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    el.style.top = top;
                    el.style.position = pos;
                }
            }, 200);
        },
        async sendForm() {
            this.sendFormLoader = true;
            this.$store.commit('removeAllErrors');

            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }

            await this.$recaptchaLoaded();
            // const token = await this.$recaptcha("form");
            const form = this.$store.getters.getValuByPath('formOrganizationStep2');
            const files = this.$store.getters.getValuByPath('files');
            let data = new FormData();

            data.append('form', JSON.stringify(form));

            for (const [key, value] of Object.entries(files)) {
                data.append(key, value);
            }
            axios
                .post(process.env.VUE_APP_API_BASE_URL + "applications/finalists/" + this.$route.params.uuid + "/store",
                    data,
                    config)
                .then((response) => {
                    if (response.status == 200 && response.data.status == 'success') {
                        this.showModal.type = 'success-finalist'
                        this.showModal.show = true
                    } else if (response.status == 200 && response.data.status == 'finalist-accept') {
                        this.showModal.type = 'finalist-accept'
                        this.showModal.show = true
                    } else {
                        this.showModal.type = 'server-error'
                        this.showModal.show = true
                    }
                    this.sendFormLoader = false
                })
                .catch((error) => {
                    if (error.response.data.errors) {
                        // const errorsf = error.response.data.errors.map((e) => {
                        //     console.log(e)
                        //     if (e.slice(0, 5) == 'form.') {
                        //         e.replace('form.', '')
                        //     }
                        //     return e;
                        // })
                        const errors = {};
                        for (const [key, value] of Object.entries(error.response.data.errors)) {
                            // console.log(key.slice(0, 5))
                            if (key.slice(0, 5) == 'form.') {
                                errors[key.replace('form.', '')] = value
                            } else {
                                errors[key] = value
                            }
                        }
                        this.$store.commit('setErrors', errors);
                        this.scrollToElement();

                    } else {
                        this.showModal.type = 'server-error'
                        this.showModal.show = true
                    }
                    this.sendFormLoader = false
                });
        },
        addBudget() {
            this.form.project.budget.push({
                name: '',
                amount: null
            })
        },
        addEntities() {
            this.form.project.other_entities_array.push({
                name: '',
                range: ''
            })
        }
    },
};
</script>
